var logoutBtn = document.getElementsByClassName('logout-btn');

if (logoutBtn.length) {

    for (let i = 0; i < logoutBtn.length; i++) {
        logoutBtn[i].addEventListener('click', e => {
            e.preventDefault();
            document.querySelector('.logout-form').submit();
        });
    }
}